import * as React from "react";
import { Box, Typography } from "@mui/material";
import IBlogo from "../../../../Assets/ib_color.png";

interface LoginCardHeaderProps {
    subheading: string;
    cardHeaderClass: string;
    logoInCardClass: string;
    headingClass: string;
    subheadingClass: string;
}

export const LoginCardHeader: React.FC<LoginCardHeaderProps> = ({
    subheading,
    cardHeaderClass,
    logoInCardClass,
    headingClass,
    subheadingClass,
}) => (
    <Box className={cardHeaderClass}>
        <img src={IBlogo} className={logoInCardClass} alt="InstaBrain logo" />
        <Typography className={headingClass}>Welcome back</Typography>
        <Typography className={subheadingClass}>{subheading}</Typography>
    </Box>
);
